// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__GqS3q","large":"styles_large__3suSd"};